import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { ArrowControls } from '../utils/_glide-plugins';

export default class TextImageSlider extends Module {

    ready(app) {
        const SLIDERS = document.querySelectorAll('.text-image-slider');

        for (let i = 0; i < SLIDERS.length; i++) {
            const SLIDER_WRAP = SLIDERS[i];
            const SLIDER = SLIDER_WRAP.querySelector('.glide');

            new Glide(SLIDER, {
                type: 'carousel',
                gap: 0,
                arrowClasses: {
                    back: 'slider-arrow--left',
                    next: 'slider-arrow--right'
                }
            }).mount({ ArrowControls });
        }
    }
}